import http from "../utils/http"
import uri from "../utils/uri"

const tokenName = 'token';
const _user = 'user';

/**
 * Logea un usuario y guarda el token
 */
const login = user => http(uri.account).asPost(user).then(resp => setToken(resp));

const changePassword = user => http(uri.changepassword).asPost(user);

const resetPassword = user => http(uri.resetPassword).asPost(user);

const loginTwoFactor = user => http(uri.loginTwoFactor).asPost(user).then(resp => {

    if(!resp.twoFactorRequired)
        setToken(resp);
    
    return resp;
});

const buildUser = ({token, ...rest}) => rest;

/**
 * Eliminar el token guardado en memoria
 */
const logout = () => {

    localStorage.removeItem(tokenName);
    localStorage.removeItem(_user);
    
} 

const logoutOnlyToken = () => {

    localStorage.removeItem(tokenName);
    
} 

/**
 * Guarda el token en memoria
 * @param {string} token -  token que se va guardar
 * @return {object} - Objeto del usuario
 */
const setToken = resp => {
    localStorage.setItem(tokenName, resp.token);
    localStorage.setItem(_user, JSON.stringify(buildUser(resp)));

    return resp;
}

/**
 * Retorna el token guardado en memoria
 * @return {string} token
 */
const getToken = () => localStorage.getItem(tokenName);

/**
 * Retorna el usuario guardado en memoria
 * @return {{ resources : []}} token
 */
const getUser = () => JSON.parse(localStorage.getItem(_user));

/**
 * Retorna el token guardado en memoria
 * @return {boolean}
 */
 const isLogged = () => getToken() != null;

 const updateSession = () =>{

    const currentTimer = new Date().getTime();

    localStorage.setItem('currentTimer', currentTimer);

 }

export const userService = {
    login,
    loginTwoFactor,
    changePassword,
    resetPassword,
    logout,
    getToken,
    getUser,
    isLogged,
    updateSession,
    logoutOnlyToken
}